module.exports = __webpack_public_path__ + "static/media/2.fefc65e5.svg";